import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import match from './zh-CN/match';
import finance from './zh-CN/finance';

export default {
  ...pages,
  ...menu,
  ...match,
  ...finance,
};
